import { BounceZoomIn, SwipeFromBottomOut, ZoomOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";
import settingsModel from "slotworks/model/settings/settings-model";
import gameState from "slotworks/model/game-state";

export default class TotalWinTransitions extends AbstractSceneTransition {

    private BOUNCE_TIME: number = 300;
    private SWIPE_TIME: number = 500;

    private noWinWin: boolean;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.noWinWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
            if(this.noWinWin) {
                this.formatLowWinText();
                if (Layers.CelebrationContent.getSprite("cshine")) {
                    Layers.CelebrationContent.getSprite("cshine").visible = false;
                }
                if (Layers.CelebrationContent.getScriptedAnimation("cshine")) {
                    Layers.CelebrationContent.getScriptedAnimation("cshine").getContainer().visible = false;
                }
                resolve(null);
            } else {
                BounceZoomIn(Layers.CelebrationContent.getSprite("value"), this.BOUNCE_TIME, 0).then(resolve);
                if (Layers.CelebrationContent.getScriptedAnimation("cshine")) {
                    BounceZoomIn(Layers.CelebrationContent.getScriptedAnimation("cshine").getContainer(), this.BOUNCE_TIME, 0).execute();
                }
                if (Layers.CelebrationContent.getSprite("shine")) {
                    BounceZoomIn(Layers.CelebrationContent.getSprite("shine"), this.BOUNCE_TIME, 0).execute();
                }
            }
        });
    }

    public out(): Contract<void> {
        return new Contract((resolve) => {
            if(this.noWinWin)
                resolve(null);
            else {
                SwipeFromBottomOut(Layers.CelebrationContent.getSprite("value"), this.SWIPE_TIME + 1, 0, TweenJS.Easing.Back.In).then(resolve);
                ZoomOut(Layers.CelebrationContent.getSprite("value"), this.SWIPE_TIME * 0.75, this.SWIPE_TIME * 0.25, TweenJS.Easing.Quadratic.In).execute();

                if (Layers.CelebrationContent.getSprite("shine")) {
                    SwipeFromBottomOut(Layers.CelebrationContent.getSprite("shine"), this.SWIPE_TIME, 0, TweenJS.Easing.Back.In).execute();
                    ZoomOut(Layers.CelebrationContent.getSprite("shine"), this.SWIPE_TIME * 0.75, this.SWIPE_TIME * 0.25, TweenJS.Easing.Quadratic.In).execute();
                }
                if (Layers.CelebrationContent.getScriptedAnimation("cshine")) {
                    SwipeFromBottomOut(Layers.CelebrationContent.getScriptedAnimation("cshine").getContainer(), this.SWIPE_TIME, 0, TweenJS.Easing.Back.In).execute();
                    ZoomOut(Layers.CelebrationContent.getScriptedAnimation("cshine").getContainer(),
                        this.SWIPE_TIME * 0.75, this.SWIPE_TIME * 0.25, TweenJS.Easing.Quadratic.In).execute();
                }
            }
        });
    }

    private formatLowWinText() {
        const text = Layers.CelebrationContent.getSprite("value");
        const scale = text.scale.x * 0.7;
        text.scale.set(scale, scale);
        text.tint = 0xcccccc;
    }

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/transitions/total-win-transitions.ts